module.exports = __webpack_public_path__ + "static/media/active-vault.7f4fc988.svg";